import _ from "lodash";
import CarouselEntity from "./CarouselEntity";

import { SlidesPerPageInterface } from "./CarouselInterface";

export default class CarouselFactory {
  static create(dom: HTMLElement): CarouselEntity {
    return new CarouselEntity(dom);
  }

  static setSlidesPerPage(
    slidesPerPage: number | SlidesPerPageInterface
  ): number | SlidesPerPageInterface {
    if (typeof slidesPerPage === "number") return slidesPerPage;

    const defaultConfig: SlidesPerPageInterface = {
      sm: { slidesPerPage: 1, size: 1185 },
      md: { slidesPerPage: 1, size: 1500 },
      lg: { slidesPerPage: 1, size: 1765 },
      xl: { slidesPerPage: 1, size: 4000 },
    };

    return _.merge(defaultConfig, slidesPerPage);
  }
}
